import { NoResults } from '@library/components/NoResults';
import { Table } from '@library/components/table';

export interface StyledTableProps {
  children: React.ReactNode;
  errorMessage: string;
  isError: boolean;
  noData: boolean;
  noDataMessage: { label: string; title: string; dataTestId: string };
}

export const StyledTable = ({
  children,
  errorMessage,
  isError,
  noData,
  noDataMessage
}: StyledTableProps) => {
  if (isError) {
    return (
      <section className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          {errorMessage}
        </h1>
      </section>
    );
  }

  if (noData) {
    return (
      <section className="p-6">
        <NoResults
          label={noDataMessage.label}
          title={noDataMessage.title}
          dataTestId={noDataMessage.dataTestId}
        />
      </section>
    );
  }

  return (
    <Table className="border-soFresh-140 h-[70vh] overflow-auto rounded-lg border p-0">
      {children}
    </Table>
  );
};
